import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMaterialAdapter from 'vue-material-adapter'
import VueCookies from 'vue-cookies'

createApp(App).use(store).use(router).use(VueCookies).use(VueMaterialAdapter).mount('#app')
